// src/modules/Developer/pages/PageContainerPage/PageContainerPage.jsx
import React, { useState } from 'react';

export default function PageContainerPage() {
  const [long, setLong] = useState(false);

  return (
    <div className="page-container">
      <h1>Заголовок страницы</h1>

      <button onClick={() => setLong(l => !l)}>
        {long ? 'Показать короткий' : 'Показать длинный'}
      </button>

      {long ? (
        Array.from({ length: 30 }, (_, i) => (
          <p key={i}>Параграф #{i + 1}</p>
        ))
      ) : (
        <p>Короткий контент — скролла нет.</p>
      )}
    </div>
  );
}
